import createRestApiClient from '../utilities/createRestApiClient'

export default () => {
  const client = createRestApiClient().withConfig({
    baseURL: window.location.hostname,
  })
  return {
    uploadToS3: ({ file, url, options }) =>
      client.request({
        method: 'PUT',
        url,
        data: file,
        ...options,
      }),
  }
}
